<template>
  <div>
    <vue-easy-lightbox
    :visible="visible"
    :imgs="images"
    :index="index"
    @hide="handleHide"
  ></vue-easy-lightbox>
    <div class="m-2 ">
      <div class="flex flex-row justify-center">
        <img
          width="600"
          src="https://fantomwheelz.com/assets/images/the_showroom_headline_01.png"
        />
      </div>
      <div class="my-4 md:my-2 p-2 justify-center flex flex-row">
        <p class="w-full md:w-3/5">
          Sleeper? Daily Driver? Racecar? All show - no go? Dark knight? Acid Mix?
          <br /><br />
          Each wheelz has an unique set of attributes. All of the attributes are carefully
          hand-crafted and drawn. Attributes are designed so that they create an aestethically
          pleasing combination - each and every time a Fantomz Wheelz is created.
          Colors and forms are picked so that they always look good.
          <br /><br />
          Here's a showroom of what we've got.
        </p>
      </div>
      <div class="text-center" v-if="loading">Loading...</div>
      <div v-else>
        <attribute-viewer @click="onImageClicked" :attributes="attributes"></attribute-viewer>
      </div>
    </div>
  </div>
</template>

<script>
import ShowAlert from '@components/ShowAlert.vue'
import WheelzHeader from '@components/WheelzHeader.vue'
import AttributeViewer from '@components/AttributeViewer.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
import { apiurl } from '@/walletHelpers.js'
export default {
  data: function () {
    return {
      loading: false,
      attributes: [],
      images: [],
      index: null,
      visible: false,
    }
  },
  methods: {
    handleHide: function () {
      this.visible = false
    },
    onImageClicked: function (_index) {
      this.index = _index
      this.visible = true
    },
    getImageURL: (avalue) => {
      return 'https://fantomwheelz.com/attributes/' + avalue + '/demoimage'
    },
  },
  mounted () {
    fetch(apiurl + '/get_attribute_gallery')
      .then((r) => r.json())
      .then((attrs) => {
        this.loading = false
        this.attributes = attrs
        this.images = Object.keys(attrs).map(key => attrs[key].values.map(val => this.getImageURL(val.id))).reduce((acc,arr) => {
          acc = [...acc, ...arr]
          return acc
        })
      })
      .catch((e) => alert(e))
  },
  components: {
    ShowAlert,
    WheelzHeader,
    AttributeViewer,
    VueEasyLightbox,
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/AttributesPage.vue